import styled from "styled-components";

export const PageWrapper = styled.main`
	display: flex;
	flex-direction: column;
	gap: 32px;
	padding-inline: 20px;
	padding-bottom: 32px;
`;
export const PageTitle = styled.h1`
	font-size: 20px;
	font-weight: bold;
	line-height: 23px;
	color: #000 !important;

	span {
		font-weight: 400;
	}
`;

export const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const TitleGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const ExportButton = styled.button`
	border: 0;
	border-radius: 8px;
	padding: 11px 18px;
	background: #fff;
	color: #584c9c;
	font-size: 14px;
	font-weight: 700;
	cursor: pointer;

	&:hover {
		background: #f8f7ff;
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const ErrorMessage = styled.div`
	margin-bottom: -16px;
	border: 1px solid #efb0b7;
	border-radius: 6px;
	padding: 12px 16px;
	background: #fff1f2;
	color: #9f1d2c;
`;
